import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { IPost } from '../../types';

interface IProps {
	post: IPost;
}

const Event = ({ post }: IProps) => {
	return (
		<a href={post.permalink} target="_self" rel="noreferrer" className="pfa-card-event">
			{!!post.featured_image && (
				<figure
					className="pfa-card-event__img-wrapper"
					dangerouslySetInnerHTML={{ __html: post.featured_image }}
				/>
			)}
			<div className="pfa-card-event__text">
				{post.post_type && (
					<div className="pfa-card-event__tag-container">
						<p
							className="pfa-card-event__tag post-tag"
							dangerouslySetInnerHTML={{
								__html: sanitizeHtml(post.post_type),
							}}
						/>
					</div>
				)}
				<div className="pfa-card-event__content cms">
					{post.post_title && (
						<h3
							className="pfa-card-event__title"
							dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_title) }}
						/>
					)}
				</div>
				{post.formatted_date && (
					<p
						className="pfa-card-event__date"
						dangerouslySetInnerHTML={{ __html: post.formatted_date }}
					/>
				)}
			</div>
		</a>
	);
};

Event.displayName = 'Event';

export default Event;
